import { Content } from "antd/es/layout/layout";
import HorizontalNav from "../../../components/common/horizontalNav";
import { Layout } from "antd";
import { Outlet } from "react-router";

const Order = () => {
  return (
    <div>
      <Layout className="bg-white">
        <div className="px-3 pt-2">
          <HorizontalNav />
        </div>
        <Layout>
          <Content className="w-full overflow-auto bg-white over">
            <div className=" bg-white">
              <Outlet />
            </div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};
export default Order;
